






























import { Component, Mixins } from "vue-property-decorator";
import { ConfirmDialogMixin } from "../../mixins";

@Component
export default class ConfirmDialog extends Mixins(ConfirmDialogMixin) {
}
